import type { Theme, ThemeId } from '../core/types';
import { narutoTheme } from './naruto/theme';
import { ryukTheme } from './ryuk/theme';
import { painTheme } from './pain/theme';

export const themes: Record<ThemeId, Theme> = {
  naruto: narutoTheme,
  ryuk: ryukTheme,
  pain: painTheme,
};

export function isThemeId(value: string): value is ThemeId {
  return Object.hasOwn(themes, value);
}
